import axios from 'axios';
import { getLeads as getApiLeads, getLeadsByEnterprise as getApiLeadsByEnterprise, getConversationByLeadId as getApiConversation, deleteLead as deleteApiLead, getApiBaseUrl } from './api';

// Helper to provide user-friendly error messages
const getErrorMessage = (error) => {
  if (error.type === 'SERVER_UNAVAILABLE') {
    return 'Server is not available. Please check your connection and try again.';
  }
  if (error.type === 'SERVER_ERROR') {
    return 'Server error occurred. Please try again later.';
  }
  if (error.type === 'TIMEOUT') {
    return 'Request timed out. Please try again.';
  }
  return error.message || 'An error occurred. Please try again.';
};

// API calls with error handling
export const getLeads = async (storeIdFk = null, options = {}) => {
  console.log('Fetching leads from API with storeIdFk:', storeIdFk, options);
  try {
    return await getApiLeads(storeIdFk, options);
  } catch (error) {
    console.error('API Error:', error);
    // 401 errors are already handled in the API interceptor with redirect
    if (error.response?.status === 401) {
      throw error;
    }
    // Cancellation requests should not be turned into generic errors
    if (axios.isCancel(error)) {
      throw error;
    }
    throw new Error(getErrorMessage(error));
  }
};

export const getLeadsByEnterprise = async (enterpriseId, storeIdFk = null, options = {}) => {
  console.log('Fetching GI leads from API for enterprise:', enterpriseId, 'storeIdFk:', storeIdFk, options);
  try {
    return await getApiLeadsByEnterprise(enterpriseId, storeIdFk, options);
  } catch (error) {
    console.error('API Error:', error);
    // 401 errors are already handled in the API interceptor with redirect
    if (error.response?.status === 401) {
      throw error;
    }
    // Cancellation requests should not be turned into generic errors
    if (axios.isCancel(error)) {
      throw error;
    }
    throw new Error(getErrorMessage(error));
  }
};

export const getConversationByLeadId = async (leadId) => {
  console.log('Fetching conversation for lead:', leadId);
  try {
    return await getApiConversation(leadId);
  } catch (error) {
    console.error('API Error:', error);
    // 401 errors are already handled in the API interceptor with redirect
    if (error.response?.status === 401) {
      throw error;
    }
    throw new Error(getErrorMessage(error));
  }
};

export const deleteLead = async (leadId) => {
  console.log('Deleting lead:', leadId);
  try {
    await deleteApiLead(leadId);
  } catch (error) {
    console.error('API Error:', error);
    // 401 errors are already handled in the API interceptor with redirect
    if (error.response?.status === 401) {
      throw error;
    }
    throw new Error(getErrorMessage(error));
  }
};
